<template>
  <div>
    <div class="sign-content">
      <!--联系信息 -->
      <el-card-title :title="title" />
      <el-form
        label-width="80px"
        :model="legalPersonForm"
        :rules="legalPersonFormRules"
        ref="legalPersonFormRef"
        class="endItem"
      >
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.legalName')"
          label-width="400px"
          :prop="isChinese === 'zh-cn' ? 'legalContactName' : ''"
        >
          <!-- 法人代表姓名 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.legalNameMsg')"
            v-model="legalPersonForm.legalContactName"
            :disabled="isSkyEyes"
            show-word-limit
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="isChinese === 'zh-cn'"
          label="手机号归属地："
          label-width="400px"
          prop="isLegalOverseaMobile"
          ><!--手机号归属地-->
          <el-select
            style="width: 430px; margin-left: 6px;"
            class="IDplac"
            v-model="legalPersonForm.isLegalOverseaMobile"
          >
            <el-option label="中国" :value="0"> </el-option>
            <el-option label="海外" :value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.legalMobile')"
          label-width="400px"
          prop="legalContactMobile"
          :rules="
            legalPersonForm.isLegalOverseaMobile === 1
              ? legalPersonFormRules.legalContactMobileOverSea
              : legalPersonFormRules.legalContactMobile
          "
          v-if="isChinese === 'zh-cn'"
        >
          <!-- 法人代表手机 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.legalMobileMsg')"
            v-model="legalPersonForm.legalContactMobile"
            show-word-limit
            :maxlength="legalPersonForm.isLegalOverseaMobile === 1 ? 50 : 11"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.legalTel')"
          label-width="400px"
          v-if="isChinese === 'zh-cn'"
          prop="legalContactTel"
        >
          <!-- 法人代表固定电话 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.legalTelMsg')"
            v-model="legalPersonForm.legalContactTel"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="法人证件类型:"
          label-width="400px"
          prop="legalCertType"
          v-if="isChinese === 'zh-cn'"
        >
          <!-- 法人证件类型 -->
          <el-select
            style="width: 430px; margin-left: 6px;"
            class="IDplac"
            v-model="legalPersonForm.legalCertType"
          >
            <el-option
              :label="$t('page.applyUsername.others.IDCard')"
              :value="1"
            >
            </el-option>
            <el-option
              :label="$t('page.applyUsername.others.aboardIDCard')"
              :value="2"
            >
            </el-option>
          </el-select>
        </el-form-item> 
        <!-- <el-form-item
          v-if="legalPersonForm.legalCertType === 1 && isChinese === 'zh-cn'"
          style="height: auto;"
          :label="$t('page.applyUsername.contentLabel.IDFront')"
          label-width="400px"
          prop="legalPositiveImageUrl"
        >
          <IDCardValidate
            style="margin-left: 6px;"
            :imageUrl="legalPersonForm.legalPositiveImageUrl"
            :exampleImg="require('@/assets/images/back.png')"
            @setUploadImageUrl="
              setUploadImageUrl($event, 'legalPositiveImageUrl', 1, 2)
            "
          />
        </el-form-item>
        <el-form-item
          v-if="legalPersonForm.legalCertType === 1 && isChinese === 'zh-cn'"
          style="height: auto;"
          :label="$t('page.applyUsername.contentLabel.IDBack')"
          label-width="400px"
          prop="legalNegativeImageUrl"
        >
          <IDCardValidate
            style="margin-left: 6px;"
            :imageUrl="legalPersonForm.legalNegativeImageUrl"
            :exampleImg="require('@/assets/images/front.png')"
            @setUploadImageUrl="
              setUploadImageUrl($event, 'legalNegativeImageUrl', 2, 2)
            "
          />
        </el-form-item> -->
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.legalID')"
          label-width="400px"
          prop="legalContactIdcard"
          :rules="
            legalPersonForm.legalCertType === 2
              ? legalPersonFormRules.legalContactIdcardOverSea
              : legalPersonFormRules.legalContactIdcard
          "

          v-if="isChinese === 'zh-cn'"
        >
          <!-- 证件号 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.legalID')"
            v-model="legalPersonForm.legalContactIdcard"
            show-word-limit
            maxlength="18"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.legalFax')"
          label-width="400px"
          v-if="isChinese === 'zh-cn'"
        >
          <!-- 法人代表传真 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.legalFaxMsg')"
            v-model="legalPersonForm.legalContactFax"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.legalEmail')"
          label-width="400px"
          prop="legalContactEmail"
          v-if="isChinese === 'zh-cn'"
        >
          <!-- 法人代表E-mail -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.legalEmailMsg')"
            v-model="legalPersonForm.legalContactEmail"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.market')"
          label-width="400px"
          :prop="isChinese === 'zh-cn' ? 'salesHeaderName' : ''"
          class="endItem"
        >
          <!-- 销售负责人 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.marketMsg')"
            v-model="legalPersonForm.salesHeaderName"
            show-word-limit
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="isChinese === 'zh-cn'"
          label="手机号归属地："
          label-width="400px"
          prop="isSaleOverseaMobile"
          ><!--手机号归属地-->
          <el-select
            style="width: 430px; margin-left: 6px;"
            class="IDplac"
            v-model="legalPersonForm.isSaleOverseaMobile"
          >
            <el-option label="中国" :value="0"> </el-option>
            <el-option label="海外" :value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.marketMobile')"
          label-width="400px"
          :prop="isChinese === 'zh-cn' ? 'salesHeaderMobile' : ''"
          :rules="
            legalPersonForm.isSaleOverseaMobile === 1
              ? legalPersonFormRules.salesHeaderMobileOverSea
              : legalPersonFormRules.salesHeaderMobile
          "
        >
          <!-- 销售负责人手机 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.marketMobileMsg')"
            v-model="legalPersonForm.salesHeaderMobile"
            show-word-limit
            :maxlength="legalPersonForm.isSaleOverseaMobile === 1 ? 50 : 11"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.marketTel')"
          label-width="400px"
          prop="salesHeaderTel"
        >
          <!-- 销售负责人固定电话 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.marketTelMsg')"
            v-model="legalPersonForm.salesHeaderTel"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="销售负责人证件类型:"
          label-width="400px"
          prop="saleCertType"
          v-if="isChinese === 'zh-cn'"
        >
          <el-select
            style="width: 430px; margin-left: 6px;"
            class="IDplac"
            v-model="legalPersonForm.saleCertType"
          >
            <el-option
              :label="$t('page.applyUsername.others.IDCard')"
              :value="1"
            >
            </el-option>
            <el-option
              :label="$t('page.applyUsername.others.aboardIDCard')"
              :value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          v-if="legalPersonForm.saleCertType === 1 && isChinese === 'zh-cn'"
          style="height: auto;"
          :label="$t('page.applyUsername.contentLabel.IDFront')"
          label-width="400px"
          prop="salePositiveImageUrl"
        >
          <IDCardValidate
            style="margin-left: 6px;"
            :imageUrl="legalPersonForm.salePositiveImageUrl"
            :exampleImg="require('@/assets/images/back.png')"
            @setUploadImageUrl="
              setUploadImageUrl($event, 'salePositiveImageUrl', 1, 3)
            "
          />
        </el-form-item>
        <el-form-item
          v-if="legalPersonForm.saleCertType === 1 && isChinese === 'zh-cn'"
          style="height: auto;"
          :label="$t('page.applyUsername.contentLabel.IDBack')"
          label-width="400px"
          prop="saleNegativeImageUrl"
        >
          <IDCardValidate
            style="margin-left: 6px;"
            :imageUrl="legalPersonForm.saleNegativeImageUrl"
            :exampleImg="require('@/assets/images/front.png')"
            @setUploadImageUrl="
              setUploadImageUrl($event, 'saleNegativeImageUrl', 2, 3)
            "
          />
        </el-form-item> -->
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.saleID')"
          label-width="400px"
          prop="salesHeaderIdcard"
          :rules="
            legalPersonForm.saleCertType === 2
              ? legalPersonFormRules.salesHeaderIdcardOverSea
              : legalPersonFormRules.salesHeaderIdcard
          "
          v-if="languagezh_cn"
        >
          <!-- 销售负责人证件号 -->
          <el-input
            class="IDplac"
            :placeholder="$t('page.contactInfo.inputPlc.saleID')"
            v-model="legalPersonForm.salesHeaderIdcard"
            show-word-limit
            maxlength="18"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.marketFax')"
          label-width="400px"
        >
          <!-- 销售负责人传真 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.marketFaxMsg')"
            v-model="legalPersonForm.salesHeaderFax"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.marketEmail')"
          label-width="400px"
          :prop="isChinese === 'zh-cn' ? 'salesHeaderEmail' : ''"
        >
          <!-- 销售负责人E-mail -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.marketEmailMsg')"
            v-model="legalPersonForm.salesHeaderEmail"
            maxlength="320"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.contactInfo.contentLabel.web')"
          label-width="400px"
        >
          <!-- 公司网址 -->
          <el-input
            :placeholder="$t('page.contactInfo.inputPlc.webMsg')"
            v-model="legalPersonForm.website"
            maxlength="100"
          ></el-input>
        </el-form-item>
      </el-form>
      <!--实控主体 -->
      <el-card-title
        :title="$t('page.contactInfo.contentLabel.controlAgent')"
        v-if="languagezh_cn"
      />
      <div
        style="width: 94%; margin-top: 40px; margin-bottom: 40px;"
        v-if="languagezh_cn"
      >
        <div style="text-align: right; margin-bottom: 10px;">
          <el-button
            plain
            type="single-number"
            class="myBtn"
            @click="addLine(1)"
          >
            {{ $t("page.productInfo.btn.newAdd") }}
          </el-button>
          <el-button
            plain
            type="single-number"
            class="myBtn"
            @click="deleteRow(1)"
          >
            {{ $t("page.productInfo.btn.del") }}
          </el-button>
        </div>
        <el-table
          ref="multipleTable"
          widthResize
          :data="mainstayTableData"
          :header-cell-class-name="must"
          class="multifunctional-table"
          style="width: 830px; margin-left: 280px;"
          border
          :max-height="99999"
          show-overflow
          @select="handleCheckChange"
          @select-all="handleCheckAllChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            type="index"
            :label="$t('page.contactInfo.contentLabel.xuhao')"
            min-width="50"
          >
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.controlType')"
            prop="mainstayTypename"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.mainstayTypename"
                :placeholder="$t('page.supInfo.inputPlc.choose')"
                @change="getSelect(scope.row, 1)"
              >
                <el-option
                  v-for="item in mainstayTypename"
                  :key="item.dicKey"
                  :label="item.dicValue"
                  :value="item.dicValue"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.controlAgent')"
            prop="mainstayName"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                :key="scope.rowIndex"
                v-model.trim="scope.row.mainstayName"
                maxlength="100"
                :placeholder="$t('page.supInfo.inputPlc.input')"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.controlId')"
            prop="mainstayIdcard"
            width="330"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                @input="invaildCard(scope.row, 'mainstayIdcard')"
                :key="scope.rowIndex"
                v-model.trim="scope.row.mainstayIdcard"
                :placeholder="$t('page.supInfo.inputPlc.input')"
                maxlength="18"
                show-word-limit
              >
              </el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--董监高 -->
      <el-card-title
        :title="$t('page.contactInfo.contentLabel.DJG')"
        v-if="languagezh_cn"
      />
      <div
        style="width: 94%; margin-top: 40px; margin-bottom: 30px;"
        v-if="languagezh_cn"
      >
        <div class="djg-title" style="text-align: right; margin-bottom: 10px;">
          <!-- <span class="tips">向右滑动，上传身份证照片后，可自动带出姓名与证件号码</span> -->
          <div>
            <el-button
              plain
              type="single-number"
              class="myBtn"
              @click="addLine(2)"
            >
              {{ $t("page.productInfo.btn.newAdd") }}
            </el-button>
            <el-button
              plain
              type="single-number"
              class="myBtn"
              @click="deleteRow(2)"
            >
              {{ $t("page.productInfo.btn.del") }}
            </el-button>
          </div>
        </div>
        <el-table
          ref="multipleTable"
          widthResize
          :data="djgTableData"
          :header-cell-class-name="must"
          class="multifunctional-table"
          style="width: 830px; margin-left: 280px;"
          border
          :max-height="99999"
          show-overflow
          @select="handleCheckChange1"
          @select-all="handleCheckAllChange1"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            type="index"
            :label="$t('page.contactInfo.contentLabel.xuhao')"
            min-width="50"
          >
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.DJGT')"
            prop="djgTypename"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.djgTypename"
                :placeholder="$t('page.supInfo.inputPlc.choose')"
                @change="getSelect(scope.row, 2)"
              >
                <el-option
                  v-for="item in djgTypename"
                  :key="item.dicKey"
                  :label="item.dicValue"
                  :value="item.dicValue"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.DJGN')"
            prop="djgName"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                :key="scope.rowIndex"
                v-model.trim="scope.row.djgName"
                maxlength="100"
                :placeholder="$t('page.supInfo.inputPlc.input')"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="董兼高证件类型"
            min-width="180"
            prop="certType"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.certType"
              >
                <el-option label="身份证" :value="1"> </el-option>
                <el-option label="境外社保" :value="2"> </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.DJGID')"
            prop="djgIdcard"
            width="330"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                :key="scope.rowIndex"
                @input="invaildCard(scope.row, 'djgIdcard')"
                v-model.trim="scope.row.djgIdcard"
                :placeholder="$t('page.supInfo.inputPlc.input')"
                maxlength="18"
                show-word-limit
              >
              </el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="身份证国徽面"
            prop="positiveImageUrl"
            :min-width="languagezh_cn ? 180 : 280"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                <IDCardValidate
                  v-if="scope.row.certType === 1 && isChinese === 'zh-cn'"
                  isButton
                  :imageUrl="scope.row.positiveImageUrl"
                  @setUploadImageUrl="
                    setDJGUploadImageUrl(
                      $event,
                      scope.row,
                      'positiveImageUrl',
                      '1'
                    )
                  "
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="身份证人像面"
            prop="negativeImageUrl"
            :min-width="languagezh_cn ? 180 : 280"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                <IDCardValidate
                  v-if="scope.row.certType === 1 && isChinese === 'zh-cn'"
                  isButton
                  :imageUrl="scope.row.negativeImageUrl"
                  @setUploadImageUrl="
                    setDJGUploadImageUrl(
                      $event,
                      scope.row,
                      'negativeImageUrl',
                      '2'
                    )
                  "
                />
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <div class="btnBox">
      <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="back()"
      >
        <span>{{ $t("basicLayout.btn")[0] }}</span>
      </el-button>
      <el-button
        class="right-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="next()"
      >
        <span>{{ $t("basicLayout.btn")[1] }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  saveSupplierRegistInfo,
  qrySupRegistContactInfo,
  qryDictByCode,
  qryIdCardByHwOcr
} from "@/api/supRegister";
import { mapActions } from "vuex";
import Setting from "@/config/index";
import Cookies from "js-cookie";
import { generateUUID } from "@/utils";
const savedLocaleKey = Setting.i18n.cookieLable;
import IDCardValidate from "../components/IDCardValidate.vue";
export default {
  name: "contactInformation",
  components: {
    IDCardValidate
  },
  data() {
    return {
      title: window.$t("page.contactInfo.contentTitle.contactsInfo"), // 联系信息
      // 表单数据
      legalPersonForm: {
        legalContactName: "",
        legalContactMobile: "",
        legalContactTel: "",
        legalContactFax: "",
        legalContactEmail: "",
        salesHeaderName: "",
        salesHeaderMobile: "",
        salesHeaderTel: "",
        salesHeaderFax: "",
        salesHeaderEmail: "",
        website: "",
        legalContactIdcard: "",
        salesHeaderIdcard: "",
        saleCertType: "",
        salePositiveImageUrl: "",
        saleNegativeImageUrl: "",
        legalCertType: "",
        legalPositiveImageUrl: "",
        legalNegativeImageUrl: "",
        isLegalOverseaMobile: 0,
        isSaleOverseaMobile: 0
      },
      fileInfoList: [],
      legalidCardIsMatched: false,
      saleidCardIsMatched: false,
      // 表单校验规则
      legalPersonFormRules: {
        legalContactName: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.legalNameMsg"),
            trigger: "blur"
          }
        ],
        legalContactMobile: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.legalMobileMsg"),
            trigger: "blur"
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: window.$t("page.contactInfo.inputRules.mobileMsg"),
            trigger: "blur"
          }
        ],
        legalContactMobileOverSea: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.legalMobileMsg"),
            trigger: "blur"
          }
        ],
        legalContactTel: [
          {
            required: false,
            message: window.$t("page.contactInfo.inputPlc.legalTelMsg"),
            trigger: "blur"
          },
          {
            pattern: /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,
            message: window.$t("page.contactInfo.inputRules.legalTelMsg"),
            trigger: "blur"
          }
        ],
        // 如果点击下一步还需要验证，则在事件加入正则验证
        legalContactFax: [
          {
            message: window.$t("page.contactInfo.inputPlc.legalFaxMsg"),
            trigger: "blur"
          },
          {
            pattern: /^(\d{3,4}-)?\d{7,8}$/,
            message: window.$t("page.contactInfo.inputRules.legalFaxMsg"),
            trigger: "blur"
          }
        ],
        legalContactEmail: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.legalEmailMsg"),
            trigger: "blur"
          },
          {
            pattern: /\@/,
            message: window.$t("page.contactInfo.inputRules.emailMsg"),
            trigger: "blur"
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: window.$t("page.contactInfo.inputRules.emailMsg"),
            trigger: "blur"
          }
        ],
        salesHeaderName: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.marketMsg"),
            trigger: "blur"
          }
        ],
        salesHeaderMobile: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.marketMobileMsg"),
            trigger: "blur"
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: window.$t("page.contactInfo.inputRules.mobileMsg"),
            trigger: "blur"
          }
        ],
        salesHeaderMobileOverSea: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.marketMobileMsg"),
            trigger: "blur"
          }
        ],
        salesHeaderTel: [
          {
            required: false,
            message: window.$t("page.contactInfo.inputPlc.marketTelMsg"),
            trigger: "blur"
          },
          {
            pattern: /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,
            message: window.$t("page.contactInfo.inputRules.marketTelMsg"),
            trigger: "blur"
          }
        ],
        salesHeaderFax: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.marketFaxMsg"),
            trigger: "blur"
          },
          {
            pattern: /^(\d{3,4}-)?\d{7,8}$/,
            message: window.$t("page.contactInfo.inputRules.marketFaxMsg"),
            trigger: "blur"
          }
        ],
        salesHeaderEmail: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.marketEmailMsg"),
            trigger: "blur"
          },
          {
            pattern: /\@/,
            message: window.$t("page.contactInfo.inputRules.emailMsg"),
            trigger: "blur"
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: window.$t("page.contactInfo.inputRules.emailMsg"),
            trigger: "blur"
          }
        ],
        legalContactIdcard: [
          {
            required: true,
            message: "请输入法人代表身份证号/境外社保号",
            trigger: "blur"
          },
          {
            required: true,
            pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}([0-9Xx])$/,
            message: window.$t("page.applyUsername.inputPlc.IDMSGValidate"),
            trigger: "blur"
          }
        ],
        legalContactIdcardOverSea: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.IDMsg"),
            trigger: "blur"
          }
        ],
        salesHeaderIdcard: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.saleID"),
            trigger: "blur"
          },
          {
            required: true,
            pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}([0-9Xx])$/,
            message: window.$t("page.applyUsername.inputPlc.IDMSGValidate"),
            trigger: "blur"
          }
        ],
        salesHeaderIdcardOverSea: [
          {
            required: true,
            message: window.$t("page.contactInfo.inputPlc.saleID"),
            trigger: "blur"
          }
        ],
        saleCertType: [
          {
            required: true,
            message: "请选择销售人员证件类型",
            trigger: "change"
          }
        ],
        legalCertType: [
          {
            required: true,
            message: "请选择法人证件类型",
            trigger: "change"
          }
        ],
        salePositiveImageUrl: [
          {
            required: true,
            message: "请上传销售人员身份证国徽面",
            trigger: "change"
          }
        ],
        saleNegativeImageUrl: [
          {
            required: true,
            message: "请上传销售人员身份证人像面",
            trigger: "change"
          }
        ],
        legalPositiveImageUrl: [
          {
            required: true,
            message: "请上传法人身份证国徽面"
          }
        ],
        legalNegativeImageUrl: [
          {
            required: true,
            message: "请上传法人身份证人像面"
          }
        ],
        isLegalOverseaMobile: [
          {
            required: true,
            message: "请选择法人手机号归属地",
            trigger: "change"
          }
        ],
        isSaleOverseaMobile: [
          {
            required: true,
            message: "请选择销售负责人手机号归属地",
            trigger: "change"
          }
        ]
      },
      supInfoApplyId: "",
      isSkyEyes: false, // 是否天眼查
      isChinese: Cookies.get(savedLocaleKey) || "zh-cn",
      //实控主体
      mainstayTableData: [],
      //实控主体-类型
      mainstayTypename: [],
      //实控主体-选中的数据
      selectVal: [],
      //董监高
      djgTableData: [],
      //董监高-类型
      djgTypename: [],
      //董监高-选中的数据
      selectVal1: [],
      supCode: ""
    };
  },
  watch: {
    "legalPersonForm.legalContactIdcard"(newValue, oldValue) {
      this.legalPersonForm.legalContactIdcard = newValue.replace(/[\W]/g, "");
    },
    "legalPersonForm.salesHeaderIdcard"(newValue, oldValue) {
      this.legalPersonForm.salesHeaderIdcard = newValue.replace(/[\W]/g, "");
    }
  },
  created() {
    if (this.$route.query.page) {
      this.changeCheckPage(5);
    }
    if (Cookies.get("access_token") || this.$route.query.tempSupinfoId) {
      this.getSupRegistContactInfo();
    }
    if (this.isChinese !== "zh-cn") {
      this.legalPersonFormRules.salesHeaderTel = [];
      this.legalPersonFormRules.salesHeaderFax = [];
      this.legalPersonFormRules.salesHeaderMobile = [];
    }
    if (this.$route.path == "/maPerfectInfo/contactInformation") {
      this.changeCheckPage(5);
      for (let i = 0; i < 2; i++) {
        this.msgCenter.$emit("ballMoveRight");
      }
    }

    this.qryDictByCode("SMPC_MAINSTAY_TYPE"); //实控主体字典
    this.qryDictByCode("SMPC_DJG_TYPE"); //董监高字典
  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    invaildCard(row, prop) {
      if (prop == "mainstayIdcard") {
        if (row.id) {
          let index = this.mainstayTableData.findIndex(i => i.id == row.id);
          this.mainstayTableData[index].mainstayIdcard = this.mainstayTableData[
            index
          ].mainstayIdcard.replace(/[\W]/g, "");
        } else if (row.mainstayId) {
          let index = this.mainstayTableData.findIndex(
            i => i.mainstayId == row.mainstayId
          );
          this.mainstayTableData[index].mainstayIdcard = this.mainstayTableData[
            index
          ].mainstayIdcard.replace(/[\W]/g, "");
        }
      } else if (prop == "djgIdcard") {
        if (row.id) {
          let index = this.djgTableData.findIndex(i => i.id == row.id);
          this.djgTableData[index].djgIdcard = this.djgTableData[
            index
          ].djgIdcard.replace(/[\W]/g, "");
        } else if (row.djgId) {
          let index = this.djgTableData.findIndex(i => i.djgId == row.djgId);
          this.djgTableData[index].djgIdcard = this.djgTableData[
            index
          ].djgIdcard.replace(/[\W]/g, "");
        }
      }
    },
    back() {
      this.changeCheckPage(4);
      this.$router.push({
        path: "/maPerfectInfo/basicInformation",
        query: { tempSupinfoId: this.$route.query.tempSupinfoId }
      });
    },
    next() {
      this.$refs.legalPersonFormRef.validate(async valid => {
        if (valid) {
          let msg = this.mainstaySubmit();
          if (msg) {
            this.$message({
              showClose: true,
              type: "error",
              message: msg,
              ccuiCustom: true
            });
            return;
          }
          let msg1 = this.djgSubmit();
          if (msg1) {
            this.$message({
              showClose: true,
              type: "error",
              message: msg1,
              ccuiCustom: true
            });
            return;
          }
          // const validateIDCard = this.validateIDCard();
          // if (!validateIDCard) return;
          try {
            const params = {
              dataSourceFlag: 0,
              isShowLoading: true,
              isOverseas: window.languagezh_cn ? 0 : 1,
              tempSupinfoId: this.supInfoApplyId,
              // supCode: '',
              saveOrCommitFlag: "2",
              supRegistTab: "6",
              // supRegistAccountInfoBO:{
              //   countyCode:sessionStorage.getItem('countyCode'),
              //   countyName:sessionStorage.getItem('countyName'),
              // },
              supRegistContactInfoBO: Object.assign(this.legalPersonForm, {
                supTempMainstayInfoBOS: this.mainstayTableData,
                supTempDjgInfoBOS: this.djgTableData,
                fileInfoList: this.fileInfoList
              })
            };
            const { data } = await saveSupplierRegistInfo(params);
            console.log(data);
            if (data.code == 0) {
              this.changeCheckPage(6);
              this.$router.push({
                path: "/maPerfectInfo/productInformation",
                query: { tempSupinfoId: this.$route.query.tempSupinfoId }
              });
            }
          } catch (err) {
            console.log(err.data.message);
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
            isError[0].scrollIntoView({ behavior: "smooth", block: "center" });
          }, 100);
          return false;
        }
      });
    },
    async getSupRegistContactInfo() {
      try {
        const { data } = await qrySupRegistContactInfo({
          tempOrFormalFlag: this.$route.query.tempOrFormalFlag
            ? this.$route.query.tempOrFormalFlag
            : 0,
          supInfoApplyId: this.$route.query.tempSupinfoId,
          isShowLoading: true
        });
        this.supCode = data.data.supCode;
        console.log(data);
        if (data.code === "0") {
          this.tycInfo = data.data.tycInfo ? JSON.parse(data.data.tycInfo) : {};
          console.log("天眼查数据", this.tycInfo);
          this.isSkyEyes = false;
          if (
            this.tycInfo.legalContactName != "" &&
            this.tycInfo.legalContactName != undefined
          ) {
            this.isSkyEyes = true;
          }
          this.legalPersonForm.legalContactName =
            data.data.supRegistContactInfoBO.legalContactName;
          this.legalPersonForm.legalContactMobile =
            data.data.supRegistContactInfoBO.legalContactMobile;
          this.legalPersonForm.legalContactTel =
            data.data.supRegistContactInfoBO.legalContactTel;
          this.legalPersonForm.legalContactFax =
            data.data.supRegistContactInfoBO.legalContactFax;
          this.legalPersonForm.legalContactEmail =
            data.data.supRegistContactInfoBO.legalContactEmail;
          this.legalPersonForm.salesHeaderName =
            data.data.supRegistContactInfoBO.salesHeaderName;
          this.legalPersonForm.salesHeaderMobile =
            data.data.supRegistContactInfoBO.salesHeaderMobile;
          this.legalPersonForm.salesHeaderTel =
            data.data.supRegistContactInfoBO.salesHeaderTel;
          this.legalPersonForm.salesHeaderFax =
            data.data.supRegistContactInfoBO.salesHeaderFax;
          this.legalPersonForm.salesHeaderEmail =
            data.data.supRegistContactInfoBO.salesHeaderEmail;
          this.legalPersonForm.website =
            data.data.supRegistContactInfoBO.website;
          this.legalPersonForm.legalContactIdcard =
            data.data.supRegistContactInfoBO.legalContactIdcard;
          this.legalPersonForm.salesHeaderIdcard =
            data.data.supRegistContactInfoBO.salesHeaderIdcard;
          this.legalPersonForm.saleCertType =
            data.data.supRegistContactInfoBO.saleCertType;
          this.legalPersonForm.salePositiveImageUrl =
            data.data.supRegistContactInfoBO.salePositiveImageUrl;
          this.legalPersonForm.saleNegativeImageUrl =
            data.data.supRegistContactInfoBO.saleNegativeImageUrl;
          this.legalPersonForm.legalCertType =
            data.data.supRegistContactInfoBO.legalCertType;
          this.legalPersonForm.legalPositiveImageUrl =
            data.data.supRegistContactInfoBO.legalPositiveImageUrl;
          this.legalPersonForm.legalNegativeImageUrl =
            data.data.supRegistContactInfoBO.legalNegativeImageUrl;
          this.legalPersonForm.isLegalOverseaMobile =
            data.data.supRegistContactInfoBO.isLegalOverseaMobile;
          this.legalPersonForm.isSaleOverseaMobile =
            data.data.supRegistContactInfoBO.isSaleOverseaMobile;
          // 校验身份证信息是否上传
          // if (
          //   this.legalPersonForm.legalCertType === 1 &&
          //   this.legalPersonForm.legalPositiveImageUrl &&
          //   this.legalPersonForm.legalNegativeImageUrl
          // ) {
          //   this.legalidCardIsMatched = true;
          // }
          // if (
          //   this.legalPersonForm.saleCertType === 1 &&
          //   this.legalPersonForm.salePositiveImageUrl &&
          //   this.legalPersonForm.saleNegativeImageUrl
          // ) {
          //   this.saleidCardIsMatched = true;
          // }
          this.supInfoApplyId = data.data.supInfoApplyId;
          this.mainstayTableData =
            data.data.supRegistContactInfoBO.supTempMainstayInfoBOS || [];
          let djgTableData =
            data.data.supRegistContactInfoBO.supTempDjgInfoBOS || [];
          for (let i = 0; i < djgTableData.length; i++) {
            const item = djgTableData[i];
            if (item.certType === 1) {
              item.idCardIsMatched = true;
            }
          }
          this.djgTableData = djgTableData;
        }
      } catch (err) {
        console.log(err.data.message);
      }
    },
    must(obj) {
      if (
        [
          "mainstayTypename",
          "mainstayName",
          "mainstayIdcard",
          "djgTypename",
          "djgName",
          "djgIdcard",
          "certType"
        ].includes(obj.column.property)
      ) {
        return "must";
      }
    },
    //新增行
    addLine(type) {
      if (type === 1) {
        this.mainstayTableData.push({
          id: generateUUID(),
          mainstayType: "",
          mainstayTypename: "",
          mainstayName: "",
          mainstayIdcard: ""
        });
      } else {
        this.djgTableData.push({
          id: generateUUID(),
          djgType: "",
          djgTypename: "",
          djgName: "",
          djgIdcard: "",
          idCardIsMatched: false,
          positiveImageUrl: "",
          negativeImageUrl: "",
          certType: "",
          fileInfoList: []
        });
      }
    },
    //删除行
    deleteRow(type) {
      let val = type === 1 ? this.selectVal : this.selectVal1;
      if (val.length == 0) {
        this.$message({
          showClose: true,
          type: "error",
          message: "请至少选择一项",
          ccuiCustom: true
        });
        return;
      }
      const ids = val.map(v => v.id);
      if (type === 1) {
        this.mainstayTableData = this.mainstayTableData.filter(v => {
          return !ids.includes(v.id);
        });
      } else {
        this.djgTableData = this.djgTableData.filter(v => {
          return !ids.includes(v.id);
        });
      }
    },
    handleCheckChange(val) {
      this.selectVal = val;
    },
    handleCheckAllChange(val) {
      this.selectVal = val;
    },
    handleCheckChange1(val) {
      this.selectVal1 = val;
    },
    handleCheckAllChange1(val) {
      this.selectVal1 = val;
    },
    // 获取字典
    async qryDictByCode(code) {
      try {
        const { data } = await qryDictByCode({ code: code });
        if (data.code === "0") {
          if (code === "SMPC_MAINSTAY_TYPE") {
            this.mainstayTypename = data.data;
          } else {
            this.djgTypename = data.data;
          }
        }
      } catch (err) {
        console.log(err.message);
      }
    },
    getSelect(row, type) {
      if (type === 1) {
        this.$set(row, "mainstayTypename", row.mainstayTypename);
        this.mainstayTypename.forEach(e => {
          if (e.dicValue == row.mainstayTypename) {
            this.$set(row, "mainstayType", e.dicKey);
          }
        });
      } else {
        this.$set(row, "djgTypename", row.djgTypename);
        this.djgTypename.forEach(e => {
          if (e.dicValue == row.djgTypename) {
            this.$set(row, "djgType", e.dicKey);
          }
        });
      }
    },
    //实控主体-非空校验
    mainstaySubmit() {
      if (window.languagezh_cn && this.mainstayTableData.length == 0) {
        return `请添加实控主体信息`;
      }
      for (let i = 0; i < this.mainstayTableData.length; i++) {
        let v = this.mainstayTableData[i];
        if (!v.mainstayType) {
          return `实控主体-第${i + 1}行, 实控类型代码不能为空`;
        }
        if (!v.mainstayTypename) {
          return `实控主体-第${i + 1}行, 实控类型不能为空`;
        }
        if (!v.mainstayName) {
          return `实控主体-第${i + 1}行, 实控主体不能为空`;
        }
        if (!v.mainstayIdcard) {
          return `实控主体-第${i + 1}行, 控制主体代码或证件号不能为空`;
        }
      }
    },
    //董监高-非空校验
    djgSubmit() {
      if (window.languagezh_cn && this.djgTableData.length == 0) {
        return `请添加董监高信息`;
      }
      for (let i = 0; i < this.djgTableData.length; i++) {
        let v = this.djgTableData[i];
        if (!v.djgType) {
          return `董监高-第${i + 1}行, 董监高类型代码不能为空`;
        }
        if (!v.djgTypename) {
          return `董监高-第${i + 1}行, 董监高类型不能为空`;
        }
        if (!v.djgName) {
          return `董监高-第${i + 1}行, 董监高人员姓名不能为空`;
        }
        if (!v.djgIdcard) {
          return `董监高-第${i + 1}行, 董监高人员证件号不能为空`;
        }
        if (!v.certType) {
          return `董监高-第${i + 1}行, 董监高人员证件类型不能为空`;
        }
        if (v.certType === 1 && !/^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}([0-9Xx])$/.test(v.djgIdcard)) {
          return `董监高-第${i + 1}行, 请输入正确的身份证号码`;
        }
      }
    },
    // 身份证校验
    validateIDCard() {
      if (this.legalPersonForm.legalCertType === 1) {
        if (!this.legalidCardIsMatched) {
          this.$message({
            showClose: true,
            type: "error",
            message: "法人人身份证校验异常",
            ccuiCustom: true,
            duration: 3000
          });
          return false;
        }
      }
      if (this.legalPersonForm.saleCertType === 1) {
        if (!this.saleidCardIsMatched) {
          this.$message({
            showClose: true,
            type: "error",
            message: "销售负责人身份证校验异常",
            ccuiCustom: true,
            duration: 3000
          });
          return false;
        }
      }
      for (let i = 0; i < this.djgTableData.length; i++) {
        const item = this.djgTableData[i];
        if (!item.certType && this.isChinese === "zh-cn") {
          this.$message({
            showClose: true,
            type: "error",
            message: `第${i + 1}行董监高人员证件类型必填`,
            ccuiCustom: true,
            duration: 3000
          });
          return false;
        }
        if (item.certType === 1) {
          if (!item.idCardIsMatched) {
            if (!item.positiveImageUrl || !item.negativeImageUrl) {
              this.$message({
                showClose: true,
                type: "error",
                message: `第${i + 1}行董监高人员身份证上传不完整，请补充上传`,
                ccuiCustom: true,
                duration: 3000
              });
            } else {
              this.$message({
                showClose: true,
                type: "error",
                message: `第${i + 1}行董监高人员身份证校验异常`,
                ccuiCustom: true,
                duration: 3000
              });
            }
            return false;
          }
        }
      }
      return true;
    },
    async qryIdCardByHwOcr(params) {
      try {
        const res = await qryIdCardByHwOcr({...params, supCode: this.supCode});
        const { idCardIsMatched, cardPersonBO } = res.data.data;
        return {
          idCardIsMatched,
          cardPersonBO
        };
      } catch (res) {
        return {
          idCardIsMatched: false,
          cardPersonBO: {}
        };
      }
    },
    async setUploadImageUrl(fileData, type, positiveFlag, contactType) {
      const setIndexMap = {
        legalPositiveImageUrl: 0,
        legalNegativeImageUrl: 1,
        salePositiveImageUrl: 2,
        saleNegativeImageUrl: 3
      };
      this.$set(this.legalPersonForm, type, fileData.ossUrl);
      this.fileInfoList[setIndexMap[type]] = {
        fileUrl: fileData.ossUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileSumm: "",
        uploadTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId,
        positiveFlag,
        contactType
      };
      // 法人身份校验
      if (["legalPositiveImageUrl", "legalNegativeImageUrl".includes(type)]) {
        if (
          this.legalPersonForm.legalPositiveImageUrl &&
          this.legalPersonForm.legalNegativeImageUrl
        ) {
          const { idCardIsMatched, cardPersonBO } = await this.qryIdCardByHwOcr(
            {
              positiveImageUrl: this.legalPersonForm.legalPositiveImageUrl,
              negativeImageUrl: this.legalPersonForm.legalNegativeImageUrl,
              contactType: "2",   // 联系人类型 1 -注册联系人，2-法人，3-销售负责人，4-常用联系人,5-董监高
            }
          );
          if (idCardIsMatched) {
            // 天眼查查询到法人信息 校验法人信息
            if (this.isSkyEyes) {
              if (this.legalPersonForm.legalContactName === cardPersonBO.name) {
                this.legalPersonForm.legalContactIdcard = cardPersonBO.idCard;
                this.legalidCardIsMatched = true;
              } else {
                this.$message({
                  showClose: true,
                  type: "error",
                  message: "上传身份证信息与法人信息不匹配，请重新上传",
                  ccuiCustom: true,
                  duration: 3000
                });
                this.legalidCardIsMatched = true;
              }
              // 天眼查未查询到法人信息 不校验法人信息
            } else {
              this.legalPersonForm.legalContactName = cardPersonBO.name;
              this.legalPersonForm.legalContactIdcard = cardPersonBO.idCard;
              this.legalidCardIsMatched = true;
            }
          } else {
            this.legalidCardIsMatched = false;
          }
        }
      }
      if (["salePositiveImageUrl", "saleNegativeImageUrl".includes(type)]) {
        if (
          this.legalPersonForm.salePositiveImageUrl &&
          this.legalPersonForm.saleNegativeImageUrl
        ) {
          const { idCardIsMatched, cardPersonBO } = await this.qryIdCardByHwOcr(
            {
              positiveImageUrl: this.legalPersonForm.salePositiveImageUrl,
              negativeImageUrl: this.legalPersonForm.saleNegativeImageUrl,
              contactType: "3",   // 联系人类型 1 -注册联系人，2-法人，3-销售负责人，4-常用联系人,5-董监高
            }
          );
          if (idCardIsMatched) {
            this.saleidCardIsMatched = true;
            this.legalPersonForm.salesHeaderName = cardPersonBO.name;
            this.legalPersonForm.salesHeaderIdcard = cardPersonBO.idCard;
          } else {
            this.saleidCardIsMatched = false;
          }
        }
      }
    },
    async setDJGUploadImageUrl(fileData, row, type, positiveFlag) {
      const setIndexMap = {
        positiveImageUrl: 0,
        negativeImageUrl: 1
      };
      this.$set(row, type, fileData.ossUrl);
      if (!row.fileInfoList) {
        row.fileInfoList = [];
      }
      row.fileInfoList[setIndexMap[type]] = {
        fileUrl: fileData.ossUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileSumm: "",
        uploadTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId,
        positiveFlag
      };
      if (row.positiveImageUrl && row.negativeImageUrl) {
        const { idCardIsMatched, cardPersonBO } = await this.qryIdCardByHwOcr({
          positiveImageUrl: row.positiveImageUrl,
          negativeImageUrl: row.negativeImageUrl,
          contactType: "5",   // 联系人类型 1 -注册联系人，2-法人，3-销售负责人，4-常用联系人,5-董监高
        });
        if (idCardIsMatched) {
          row.idCardIsMatched = true;
          row.djgIdcard = cardPersonBO.idCard;
          row.djgName = cardPersonBO.name;
        } else {
          row.idCardIsMatched = false;
        }
      }
    },
    legalCertTypeChange(val) {
      if (val === 1) {
        this.legalPersonForm.legalContactIdcard = "";
        this.$message({
          message: "上传身份证并校验通过后法人证件号自动带出",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.legalidCardIsMatched = false;
      }
      if (val === 2) {
        this.legalidCardIsMatched = false;
        this.legalPersonForm.legalNegativeImageUrl = "";
        this.legalPersonForm.legalNegtiveFileinfoId = "";
        this.legalPersonForm.legalPositiveImageUrl = "";
        this.legalPersonForm.legalPositiveFileinfoId = "";
        this.fileInfoList[0] = null;
        this.fileInfoList[1] = null;
      }
    },
    saleCertTypeChange(val) {
      if (val === 1) {
        this.linkmanForm.salesHeaderName = "";
        this.linkmanForm.salesHeaderIdcard = "";
        this.$message({
          message: "上传身份证并校验通过后销售负责人信息和证件号自动带出",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.saleidCardIsMatched = false;
      }
      if (val === 2) {
        this.saleidCardIsMatched = false;
        this.legalPersonForm.saleNegativeImageUrl = "";
        this.legalPersonForm.saleNegtiveFileinfoId = "";
        this.legalPersonForm.salePositiveFileinfoId = "";
        this.legalPersonForm.salePositiveImageUrl = "";
        this.fileInfoList[2] = null;
        this.fileInfoList[3] = null;
      }
    },
    certTypeChange(val, row) {
      if (val === 1) {
        row.djgName = "";
        row.djgIdcard = "";
        this.$message({
          message: "上传身份证并校验通过后董监高信息和证件号自动带出",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        row.idCardIsMatched = false;
      }
      if (val === 2) {
        row.positiveImageUrl = "";
        row.negativeImageUrl = "";
        row.negtiveFileinfoId = "";
        row.positiveFileinfoId = "";
        row.fileInfoList = [];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.endItem ::v-deep .el-input__inner {
  padding-right: 67px;
}
/deep/th .cell {
  word-break: break-word !important;
}
.sign-content {
  width: 1180px;
  background: #ffffff;
  margin: 20px auto;
  overflow: hidden;

  .el-card-title {
    /deep/ .details-title {
      color: black;
      border-bottom: 0px;
      top: 20px;
      margin-left: 230px;
    }
  }
  .el-form {
    //margin-left: 214px;
    margin-top: 20px;
    .el-form-item .el-input {
      margin-left: 6px;
      width: 430px;
    }
    .el-form-item .el-form-item__label {
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #4a4a4a;
      text-align: right;
      line-height: 18px;
      font-weight: 400;
    }
  }

  /deep/.el-table .el-table__body-wrapper .el-table__body tr td {
    height: 36px;
  }
}
.btn {
  width: 240px;
  height: 40px;
  background: #ff142f;
  margin-bottom: 20px;
  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}
.btnBox {
  margin: 0px auto;
  width: 500px;
}
/deep/.myBtn {
  background: none;
  span {
    color: #ff142f;
  }
}
/deep/.el-button.el-button--single-number {
  border: 1px solid #ff142f;
  &:hover {
    border: 1px solid #ff142f;
  }
}
/deep/.IDplac input {
  padding-right: 45px;
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
/*.djg-title {
  display: flex;
  justify-content: space-between;
  margin-left: 280px;
  align-items: center;
  margin-bottom: 10px;
  .tips {
    color: red;
    font-size: 12px;
  }
}*/
</style>
